<template>
  <div class="tag-anchor" :style="styles">
    <div
      class="tag-line"
      :style="lineStyle"
    ></div>
    <div
      v-if="tailPosition !== 'none'"
      class="tag-dot"
      :style="{ backgroundColor: tailColourEffective}"
    ></div>
    <div
      class="tag-basic"
      :class="[
        { 'tag-basic--box-shadow' : boxShadow },
        { 'tag-basic--sold-out-label' : showSoldLabel },
        { 'tag-basic--filtered': filtered}
      ]"
      :dir="activeLanguage.dir"
      ref="el"
      :style="labelStyle"
      @click="triggerAction"
      v-html="parsedLabel"
    ></div>
  </div>
</template>
<script>
export default {
    props: {
    'background-colour': {
      default: '#FFFFFF'
    },
    action: {
      default: () => ({
        method: '',
        payload: [],
        meta: {
          objectFit: 'cover'
        }
      }),
      type: Object
    },
    'box-shadow': {
      default: true
    },
    'colour': {
      default: '#676767'
    },
    'font-size': {
      default: 0.75
    },
    'label': {
      type: Object
    },
    'padding': {
      default: () => [0.5, 1.1, 0.4, 1.1],
      type: Array
    },
    'rotation': {
      default: 0
    },
    'tail-height': {
      default: 4
    },
    'tail-position': {
      default: 'none'
    },
    'tail-colour': {
      default: null
    },
    'text-colour': {
      default: '#000000'
    },
    'pos': {
      default: () => ({
        x: 100,
        y: 100,
      }),
      type: Object
    },
    'show-sold-label': {
      default: false
    },
    filtered: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    parsedLabel() {
      if (typeof this.label === 'string') return this.label
      return this.label[this.activeLanguage.code] || this.label['en']
    },

    activeLanguage () {
      return this.$store.getters.language
    },

    styles () {
      return {
        left: `${(this.pos.x / 20)}em`,
        top: `${(this.pos.y / 20)}em`,
        transform: `rotate(${this.rotation}deg)`
      }
    },

    labelStyle () {
      let style = {
        color: this.textColour,
        backgroundColor: this.backgroundColour,
        fontSize: this.fontSize + 'em',
        paddingTop: this.padding[0] + 'em',
        paddingLeft: this.padding[3] + 'em',
        paddingBottom: this.padding[2] + 'em',
        paddingRight: this.padding[1] + 'em',
      }

      switch (this.tailPosition) {
        case 'none':
          return style

        case 'bottom-left':
          return {
            ...style,
            bottom: 0,
            transform: `translate(-1em, -${this.tailHeight / this.fontSize}em)`,
          }

        case 'bottom-center':
          return {
            ...style,
            bottom: 0,
            left: '50%',
            transform: `translate(-50%, -${this.tailHeight / this.fontSize}em)`,
          }

        case 'bottom-right':
          return {
            ...style,
            bottom: 0,
            right: 0,
            transform: `translate(1em, -${this.tailHeight / this.fontSize}em)`,
          }

        case 'top-left':
          return {
            ...style,
            transform: `translate(-1em, ${this.tailHeight / this.fontSize}em)`,
          }

        case 'top-center':
          return {
            ...style,
            left: '50%',
            transform: `translate(-50%, ${this.tailHeight / this.fontSize}em)`,
          }

        case 'top-right':
          return {
            ...style,
            right: 0,
            transform: `translate(1em, ${this.tailHeight / this.fontSize}em)`,
          }

        case 'left-center':
          return {
            ...style,
            left: 0,
            top: '.125em',
            transform: `translate(${this.tailHeight / this.fontSize}em, -50%)`,
          }

        case 'right-center':
          return {
            ...style,
            right: 0,
            top: '.125em',
            transform: `translate(-${this.tailHeight / this.fontSize}em, -50%)`,
          }

        default:
          return style
      }
    },

    tailColourEffective() {
      return this.tailColour || this.backgroundColour;
    },


    lineStyle () {
      let style = {
        backgroundColor: this.tailColourEffective,
        display: this.tailPosition !== 'none' ? this.tailPosition : 'none',
        zIndex: 6,
      }

      switch (this.tailPosition) {
        case 'bottom-left':
          return {
            ...style,
            height: `${this.tailHeight}em`,
            transform: `translateY(-${this.tailHeight}em)`
          }

        case 'bottom-center':
          return {
            ...style,
            height: `${this.tailHeight}em`,
            transform: `translateY(-${this.tailHeight}em)`
          }

        case 'bottom-right':
          return {
            ...style,
            height: `${this.tailHeight}em`,
            transform: `translateY(-${this.tailHeight}em)`
          }

        case 'top-left':
          return {
            ...style,
            bottom: 0,
            height: `${this.tailHeight}em`,
            transform: `translateY(${this.tailHeight}em)`
          }

        case 'top-center':
          return {
            ...style,
            bottom: 0,
            height: `${this.tailHeight}em`,
            transform: `translateY(${this.tailHeight}em)`
          }

        case 'top-right':
          return {
            ...style,
            bottom: 0,
            height: `${this.tailHeight}em`,
            transform: `translateY(${this.tailHeight}em)`
          }

        case 'left-center':
          return {
            ...style,
            height: `.25em`,
            right: `0`,
            top: `-0.125em`,
            width: `${this.tailHeight}em`,
            transform: `translateX(0)`
          }

        case 'right-center':
          return {
            ...style,
            height: `.25em`,
            left: `0`,
            top: `-0.125em`,
            width: `${this.tailHeight}em`,
            transform: `translateX(-${this.tailHeight}em)`
          }

        default:
          return ''
      }
    },
  },

  methods: {
    triggerAction () {
      if (this.action && this.action.method) {
        this.$store.dispatch(`actions/${this.action.method}`, {
          payload: this.action.payload,
          tag: {
            label: this.label,
            colour: this.colour,
            textColour: this.textColour,
            backgroundColour: this.backgroundColour,
          },
          meta: this.action.meta,
        })
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.tag-anchor {
  font-size: 1em;
  position: absolute;
  pointer-events: none;
  transition: transform 200ms ease-in-out, opacity 200ms ease-in-out, box-shadow 200ms ease-in-out;
  z-index: var(--tag-z-index);
  opacity: 0;
  transform: translateY(1rem);

  &.enter {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 1.2s, transform 0.6s;
  }

  &.inactive {
    opacity: .5 !important;
  }
}

.tag-dot {
  border-radius: 50%;
  bottom: -.25em;
  height: .5em;
  left: -.25em;
  pointer-events: auto;
  position: absolute;
  width: .5em;
}

.tag-line {
  left: -.125em;
  pointer-events: auto;
  position: absolute;
  width: .25em;
}

.tag-basic {
  border-radius: var(--border-radius-sm);
  font-family: var(--font-family-secondary);
  font-weight: var(--font-weight-secondary);
  letter-spacing: .1em;
  line-height: 1.1;
  width: max-content;
  pointer-events: auto;
  position: absolute;
  text-align: center;
  text-transform: uppercase;
  user-select: none;

  &--box-shadow {
    box-shadow: var(--tag-box-shadow);
  }

  &--sold-out-label {
    &::before {
      background: #e90303;
      border-radius: .4rem;
      color: #fff;
      content: 'sold out';
      font-size: .6rem;
      overflow: hidden;
      padding: .3rem .3rem .2rem;
      position: absolute;
      left: 50%;
      transform: rotate(15deg) translate(-50%, -50%);
      transform-origin: left;
      top: 50%;
      width: max-content;
    }
  }

  &--filtered {
    opacity: 0.5;
  }
}
</style>
